import React, {useRef, useState, useEffect} from "react"
import * as Ladda from "ladda"
import PropTypes from "prop-types"

function LoadingButton({
  className,
  onClick,
  disabled,
  is_loading,
  children
}) {
  const ref = useRef(null)
  const [promise_is_loading, set_promise_is_loading] = useState(!!is_loading)

  function on_button_click(e) {
    if (promise_is_loading) return

    set_promise_is_loading(true)
    function on_click_callback() {
      set_promise_is_loading(false)
    }
    const promise = onClick(e)
    if (promise?.then) {
      promise.then(on_click_callback, on_click_callback)
    }
  }

  useEffect(() => {
    set_promise_is_loading(!!is_loading)
  }, [is_loading])

  useEffect(() => {
    if (!ref) return

    const loader = Ladda.create(ref.current)
    if (is_loading || promise_is_loading) {
      loader.start()
    } else {
      loader.stop()
    }
  }, [promise_is_loading, ref])

  return (
    <button
      ref={ref}
      disabled={disabled}
      className={className}
      onClick={on_button_click}
      data-style="zoom-out">
      {children}
    </button>
  )
}

LoadingButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  is_loading: PropTypes.bool,
  children: PropTypes.node
}

export default LoadingButton
